import Accordion from "components/Accordion";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { AccordionAdapterProps } from ".";

const AccordionAdapter = ({
  blok: { content: items, variant },
  sbEditable,
}: ReactStoryblokComponent<AccordionAdapterProps>) => (
  <Accordion items={items} variant={variant} sbEditable={sbEditable} />
);

export default AccordionAdapter;
